import { observeCustomElements } from './mutationObserver.js'

// Cart Drawer

class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.cartDrawer = this;
    this.drawerFreeDel = 0;
    this.cartDrawerGoal = this.querySelector(".cart-drawer-goal") || document.querySelector(".cart-drawer-goal");
    this.goalDrawerMsg = this.cartDrawerGoal?.querySelector(".drawer-goal-msg") || '';
    this.goalDrawerProgress = this.cartDrawerGoal?.querySelector("progress") || '';

    if (this.cartDrawerGoal) {
      this.drawerFreeDel = parseInt(this.cartDrawerGoal.getAttribute("data-free"));
    }

    // Hide empty state if cart has items
    this.updateEmptyState();

    this.cartCounter();
    this.handleTrashButtons();
    this.lineItemPrice();
    this.handleNoteInput();
    this.cartDrawerBtns();
  }

  updateEmptyState() {
    const emptyState = this.querySelector(".cart-drawer-empty");
    const cartForm = this.querySelector(".cart-drawer-form");
    
    if (!emptyState) return;

    if (cartForm) {
      // Cart has items - hide empty state
      emptyState.classList.add("hidden");
    } else {
      // Cart is empty - show empty state
      emptyState.classList.remove("hidden");
    }
  }

  loaderState(loading) {
    const loader = this.cartDrawer?.querySelector("aside > .loader");
    if (!loader) return;
    loader.classList.toggle("hidden", !loading);
  }

  cartCounter() {
    const counters = this.querySelectorAll('.quantity-counter-drawer');
    counters.forEach(counter => {
      const decreaseButton = counter.querySelector('.decrease');
      const increaseButton = counter.querySelector('.increase');
      const quantityInput = counter.querySelector('input.quantity');
      const key = counter.closest(".cart-item-drawer").getAttribute("data-key");
      const max = Number(quantityInput.getAttribute("max"));
      let value = Number(quantityInput.value);

      const buttonState = (quantity) => {
        decreaseButton.disabled = quantity <= 1;
        increaseButton.disabled = quantity >= max;
      };

      buttonState(value);

      quantityInput.addEventListener('change', e => {
        value = Math.min(Math.max(1, e.target.value), max);
        e.target.value = value;
        buttonState(value);
        this.changeItemQuantity(key, value);
      });

      decreaseButton.addEventListener('click', () => {
        value = Math.max(1, parseInt(quantityInput.value) - 1);
        quantityInput.value = value;
        buttonState(value);
        this.changeItemQuantity(key, value);
      });

      increaseButton.addEventListener('click', () => {
        value = Math.min(max, parseInt(quantityInput.value) + 1);
        quantityInput.value = value;
        buttonState(value);
        this.changeItemQuantity(key, value);
      });
    });
  }

  handleTrashButtons() {
    const removes = this.querySelectorAll(".drawer-trash-item");
    removes.forEach(remove => {
      remove.addEventListener("click", e => {
        e.preventDefault();
        let svg  = remove.querySelector("svg")
        svg.classList.add("animate")
        this.loaderState(true);
        const item = remove.closest(".cart-item-drawer");
        const key = item.getAttribute("data-key");

        axios.post("/cart/change.js", { id: key, quantity: 0 }).then(res => {
          const format = this.querySelector("[data-money-format]")?.getAttribute("data-money-format");

           if (res.data.items.length === 0) {
             this.querySelector(".cart-drawer-header")?.remove();
             this.querySelector(".cart-drawer-form")?.remove();
             const emptyState = this.querySelector(".cart-drawer-empty");
             if (emptyState) {
               emptyState.classList.remove("hidden");
               emptyState.classList.add("drawer_empty_main");
             }
             document.querySelectorAll(".cart__count").forEach(icon => icon.classList.remove("show_cart"));
           } else {
            const itemCount = res.data.item_count;
            const totalPrice = cartMoneyFormat(res.data.total_price, format);
            const totalDiscount = cartMoneyFormat(res.data.total_discount, format);
            this.querySelector(".drawer-item-count").textContent = itemCount;
            this.querySelector(".drawer-total-price").textContent = totalPrice;
            this.querySelector(".drawer-total-discount").textContent = totalDiscount;
            this.freeDeliveryDrawer(res.data.total_price, format);
            item.remove();
          }

          this.loaderState(false);
        });
      });
    });
  }

  freeDeliveryDrawer(totalPrice, format) {
    if (!this.cartDrawerGoal) return;
    if (totalPrice >= this.drawerFreeDel) {
      this.goalDrawerMsg.innerHTML = "You've got free shipping";
    } else {
      const diff = this.drawerFreeDel - totalPrice;
      this.goalDrawerMsg.innerHTML = `You're only ${cartMoneyFormat(diff, format)} away from free shipping.`;
    }
    this.goalDrawerProgress.value = totalPrice;
  }

  handleNoteInput() {
    const noteInput = this.querySelector("[name='note']");
    if (!noteInput) return;
    const debounce = (func, wait, immediate) => {
      let timeout;
      return function () {
        const context = this, args = arguments;
        const later = () => {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    };
    noteInput.addEventListener("keyup", debounce(e => {
      axios.post("/cart/update.js", { note: e.target.value });
    }, 500));
  }

  async changeItemQuantity(key, quantity) {
    this.loaderState(true);
    const format = this.querySelector("[data-money-format]")?.getAttribute("data-money-format");

    try {
      const res = await axios.post("/cart/change.js", { id: key, quantity });
      const item = res.data.items.find(i => i.key === key);
      if (!item) return;
      const itemPrice = cartMoneyFormat(item.final_line_price, format);

      this.querySelector(".drawer-item-count").textContent = res.data.item_count;
      this.querySelector(".drawer-total-price").textContent = cartMoneyFormat(res.data.total_price, format);
      this.querySelector(".drawer-total-discount").textContent = cartMoneyFormat(res.data.total_discount, format);
      this.querySelector(`[data-key="${key}"] .drawer_line_item_price`).textContent = itemPrice;
      this.freeDeliveryDrawer(res.data.total_price, format);
    } finally {
      this.loaderState(false);
    }
  }

  lineItemPrice() {
    this.querySelectorAll(".cart-item-drawer").forEach(item => {
      const key = item.getAttribute("data-key");
      const quantity = item.querySelector(".quantity-counter-drawer input").value;
      this.changeItemQuantity(key, quantity);
    });
  }

  cartDrawerBtns() {
    const cartClose = this.querySelector(".cart_close");
    const cartBtns = document.querySelectorAll(".cart_drawer_btn");
    const accordion = this.querySelector(".accordion-drawer");

    cartBtns.forEach(btn => {
      btn.addEventListener("click", () => {
        this.cartDrawer?.classList.add("drawer-active");
      });
    });

    cartClose?.addEventListener("click", () => {
      this.cartDrawer?.classList.remove("drawer-active");
    });

    document.addEventListener("keyup", e => {
      if (e.key === "Escape") {
        this.cartDrawer?.classList.remove("drawer-active");
      }
    });

    if (accordion) {
      const accordionContent = this.querySelector('.accordion-content-drawer');
      const icon = accordion.querySelector('.accor-plus-img');
      accordion.addEventListener('click', () => {
        icon?.classList.toggle('rotate');
        accordionContent?.classList.toggle('active');
      });
    }
  }
}

if(!customElements.get("cart-drawer")){
  customElements.define('cart-drawer', CartDrawer);
}